//import errorHandler from './errorHandler'
import publicApi from '../../../api/public.js'
import publicV2Api from '../../../api/publicV2.js'
import axios from 'axios'
import { retryCallback } from '../../retry-utils'
import _ from 'lodash'

export default {
    sendEngagementData : (payload, next) => {
        publicApi.post(`/api/v2/eventLogs?pageId=${payload.query.pageId}`, payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    sendEngagementDataV2 : (payload, next) => {
        publicV2Api.post(`/visitor-events`, payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        })
    },
    askQuestion: (payload, next) => {
        // Handle the main chat/ask endpoint
        let path = `/chat/ask?pageId=${payload.query.pageId}`;
        
        if (payload.query.threadId) {
            path += `&threadId=${payload.query.threadId}`;
        }
        
        if (payload.query.replied) {
            path += `&replied=${payload.query.replied}`;
        }
        
        if (payload.query.local) {
            path += `&local=true`;
        }

        publicV2Api.post(path, payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        });
    },
    getFollowUpText: (payload, next) => {
        publicV2Api.post(`/agent/follow-up-text`, payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        });
    },
    checkOrderStatus: (payload, next) => {
        // This uses the older API endpoint structure
        publicV2Api.post(`/shopify-orders/status`, payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        });
    },
    retrainData: (payload, next) => {
        publicV2Api.post(`/training/retrain?pageId=${payload.query.pageId}`, payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        });
    },
    getOrderStatus: (payload, next) => {
        publicV2Api.get(`/shippy-pro/tracking/${payload.query.orderId}`, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        });
    },
    getPredefinedQuestions: (payload, next) => {
        publicV2Api.get(`/agent/predefined-questions?pageId=${payload.query.pageId}&limit=${payload.query.limit}`, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        });
    },
    getShopifyProduct: (payload, next) => {
        // Fetch single Shopify product JSON with retry logic
        const requestFn = (wrappedCallback) => {
            // Extract base URL without query parameters and add .json
            const urlObj = new URL(payload.url);
            const baseUrl = urlObj.origin + urlObj.pathname + '.json';
            
            axios.get(baseUrl)
                .then((response) => wrappedCallback(null, response.data))
                .catch((error) => wrappedCallback(error, null));
        };

        retryCallback(requestFn, next);
    },
    getShopifyProductsMultiple: (payload, next) => {
        // Fetch multiple Shopify products with retry logic - just return raw data
        let promises = [];
        const visitorLanguage = payload.visitorLanguage;

        payload.urls.forEach((urlObject) => {
            let promise = new Promise((resolve) => {
                const urlObj = new URL(urlObject.url);
                const baseUrl = urlObj.origin + urlObj.pathname + '.json';
                
                // Build localized URL if visitorLanguage is provided
                // e.g., /products/xxx.json -> /fr/products/xxx.json
                let localizedUrl = null;
                if (visitorLanguage) {
                    const pathWithoutLeadingSlash = urlObj.pathname.replace(/^\//, '');
                    localizedUrl = urlObj.origin + '/' + visitorLanguage + '/' + pathWithoutLeadingSlash + '.json';
                }

                const fetchProduct = (url, fallbackUrl = null) => {
                    const requestFn = (wrappedCallback) => {
                        axios.get(url)
                            .then((response) => wrappedCallback(null, response.data))
                            .catch((error) => wrappedCallback(error, null));
                    };

                    retryCallback(requestFn, (err, data) => {
                        if (err && fallbackUrl) {
                            // Try fallback URL if localized version failed
                            fetchProduct(fallbackUrl, null);
                        } else if (err) {
                            resolve({ error: err, urlObject: urlObject });
                        } else {
                            resolve({ data: data, urlObject: urlObject });
                        }
                    });
                };

                // If we have a localized URL, try it first with fallback to default
                if (localizedUrl) {
                    fetchProduct(localizedUrl, baseUrl);
                } else {
                    fetchProduct(baseUrl);
                }
            });

            promises.push(promise);
        });

        Promise.all(promises)
            .then((results) => {
                next(null, results);
            })
            .catch((error) => {
                next(error, null);
            });
    }
} 
